import { defineStore } from 'pinia'

// v2 §Banners & Toast — concrete Pinia singleton backing the toast queue.
// (NOT a bare module-level reactive() — that risks cross-request state bleed
// under SSR and is not this app's convention; toasts are dispatched client-side.)
export interface ToastItem {
  id?: number
  variant?: 'success' | 'info' | 'warning' | 'error' // +warning (v2 §Feedback & System L836–839)
  message: string
  duration?: number // ms; 0 = sticky
}

// v2 §Feedback & System L840 — at most 3 toasts stacked
const MAX_STACK = 3
// module-level counter for ids only (not reactive state — no SSR bleed risk)
let _uid = 0

export const useToastStore = defineStore('storeToast', {
  state: () => ({
    toasts: [] as Required<ToastItem>[],
  }),
  actions: {
    push(toast: ToastItem) {
      const id = ++_uid
      const variant = toast.variant ?? 'success'
      // v2 §Feedback & System L836–840: success/info/warning auto-dismiss at 5s; errors are STICKY (0).
      // Explicit `duration` in the call still wins (spread below).
      const duration = variant === 'error' ? 0 : 5000
      const item = { id, variant, duration, ...toast } as Required<ToastItem>
      // cap the stack at 3 — drop the oldest so the newest is always visible
      if (this.toasts.length >= MAX_STACK) this.toasts.splice(0, this.toasts.length - (MAX_STACK - 1))
      this.toasts.push(item)
      return id
    },
    dismiss(id: number) {
      const i = this.toasts.findIndex((t) => t.id === id)
      if (i !== -1) this.toasts.splice(i, 1)
    },
    clear() {
      this.toasts = []
    },
  },
})
